import { render, staticRenderFns } from "./AdminCreate.vue?vue&type=template&id=0ab416bc&"
import script from "./AdminCreate.vue?vue&type=script&lang=ts&"
export * from "./AdminCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports